import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Slider from "react-slider";
import { RingLoader } from "react-spinners";
import AVReactPlayer from "./AVReactPlayer";
import { useMediaQuery } from "react-responsive";
import Switch from "react-switch";
import PlaceholderLoading from "react-placeholder-loading";
/* import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css"; */
import CircularProgressBar from "./CircularProgressBar";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const thumbnailContainerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    overflowX: "hidden",
    margin: "1px",
};

const ThumbnailContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflowX: "hidden",
    padding: 10px 0;
    --s: 3px; /* control the size */
    --c: #2d2727;
    background: conic-gradient(at 50% var(--s), var(--c) 75%, #0000 0) 0 0 /
        calc(2 * var(--s)) calc(100% - var(--s)) padding-box;
    border: var(--s) solid var(--c);
    padding: calc(var(--s) * 2.5) calc(var(--s) * 1.5);
    box-sizing: content-box;
`;

const Thumbnail = styled.img`
    max-width: 100%;
    max-height: 100%;
    display: block;
    cursor: pointer;
    border-radius: 4px; /* Скругленные углы */
    margin-right: 20px; /* Отступ между миниатюрами */
    display: inline-block;
    transition: transform 0.2s; /* Анимация для увеличения */

    &:hover {
        transform: scale(1.1); /* Увеличение при наведении */
    }
`;

const SkeletonThumbnail = styled(Skeleton)`
    border-radius: 4px; /* Скругленные углы */
    margin-right: 20px; /* Отступ между миниатюрами */
    display: inline-block;
    margin-top: 3px; /* Отступ сверху */
    height: 35px; /* Высота скелетона */
    width: 40px; /* Ширина скелетона */
`;

const StyledThumb = styled.div`
    height: 60px;
    width: 9px;
    background: linear-gradient(to right, #bbb, #777);
    cursor: grab;
    border-radius: 25px;
    border: 2px solid #ccc;
`;

const Thumb = (props, state) => <StyledThumb {...props} />;

const StyledTrack = styled.div`
    top: 10px;
    bottom: 0;
    border-radius: 10px;
    background: ${(props) =>
        !props.switchValue1
            ? props.index === 2
                ? "#ddd"
                : props.index === 1
                ? "#0fa"
                : "#ddd"
            : props.index === 2
            ? "#0fa"
            : props.index === 1
            ? "#ddd"
            : "#0fa"};
`;

const Track = ({ index, switchValue1, ...props }) => (
    <StyledTrack {...props} index={index} switchValue1={switchValue1} />
);

const Container = styled.div`
    /* Стили для контейнера */
`;

const StyledSlider = styled(Slider)`
    width: 100%;
    height: 50px;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em; // Измените размер шрифта для увеличения кнопки
    padding: 10px 20px; // Увеличьте отступы для увеличения кнопки
    border-radius: 5px;
    font-weight: bold;
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em;
    padding: 10px 20px;
    border-radius: 5px;
    font-weight: bold;
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; // Use the full height of the viewport
    width: 100%; // Use the full width
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const TooltipContainer = styled.div`
    position: absolute;
    top: -35px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 15px;
`;

const Tooltip = styled.div`
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 0.9em;
`;

const HiddenDiv = styled.div`
    display: ${({ show }) => (show ? "block" : "none")};
    margin-top: 20px;
`;

const ToggleButton = styled.button`
    width: 100%;
    background-color: #e0e0e0;
    color: #333;
    padding: 10px;
    border: none;
    text-align: center;
    font-size: 1em;
    cursor: pointer;
    border-radius: 5px;
`;

const convertToTime = (value) => {
    const hours = Math.floor(value / (60 * 60 * 1000));
    const minutes = Math.floor((value - hours * 60 * 60 * 1000) / (60 * 1000));
    const seconds = Math.floor(
        (value - hours * 60 * 60 * 1000 - minutes * 60 * 1000) / 1000
    );
    const milliseconds = value % 1000;
    return [hours, minutes, seconds, milliseconds];
};

const formatTime = ([hours, minutes, seconds, milliseconds]) => {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
    )}:${String(seconds).padStart(2, "0")}.${String(milliseconds).padStart(
        3,
        "0"
    )}`;
};

const AVTrimSlider = (props) => {
    const {
        titleDownload,
        titleDelete,
        titleAdditionalOptions,
        titleTrimAnotherVideo,
        titleTrim,
        titleHours,
        titleMinutes,
        titleSeconds,
        titleMilliseconds,
        titleStart,
        titleEnd,
        titleReady,
        titleCurrentFile,
        titleEndToStart,
        titleFadeInAudio,
        titleFadeInVideo,
        titleFadeOutAudio,
        titleFadeOutVideo,
        tip1,
        tip2,
        tip3,
        tip4,
        tip5,
    } = props.attributes;

    const [sliderValue, setSliderValue] = useState([0, props.duration]);
    const [startValue, setStartValue] = useState(convertToTime(0));
    const [endValue, setEndValue] = useState(convertToTime(props.duration));
    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [switchValue1, setSwitchValue1] = useState(false);
    const [switchValue2, setSwitchValue2] = useState(false);
    const [showPlayer, setShowPlayer] = useState(true);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [thumbnails, setThumbnails] = useState([]);
    const [showOptions, setShowOptions] = useState(false);

    const [fadeInAudio, setFadeInAudio] = useState(false);
    const [fadeInVideo, setFadeInVideo] = useState(false);
    const [fadeOutAudio, setFadeOutAudio] = useState(false);
    const [fadeOutVideo, setFadeOutVideo] = useState(false);

    const [firstFadeInActivation, setFirstFadeInActivation] = useState(true);
    const [firstFadeOutActivation, setFirstFadeOutActivation] = useState(true);

    const [isFileDownloading, setIsFileDownloading] = useState(false);
    const [downloadProgress, setDownloadProgress] = useState(0);

    useEffect(() => {
        setSliderValue([0, props.duration]);
        setStartValue(convertToTime(0));
        setEndValue(convertToTime(props.duration));
        setThumbnails([]); // Очищаем фреймы при изменении видео

        let isCancelled = false;

        const fetchFrames = async () => {
            const initRequestBody = {
                fileid: props.fileId,
                duration: props.duration,
                screenWidth: screenWidth, // Используем текущую ширину окна
            };

            try {
                const initResponse = await fetch("/api/initFrames", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(initRequestBody),
                });

                if (initResponse.ok) {
                    const initResult = await initResponse.json();
                    console.log(
                        `Minimum Thumbnails: ${initResult.minThumbnails}`
                    );
                    for (let i = 0; i < initResult.minThumbnails; i++) {
                        setThumbnails((prev) => [...prev, null]); // Добавляем скелетоны
                    }
                    fetchNextFrame();
                } else {
                    console.error(
                        "Error initializing frames:",
                        initResponse.statusText
                    );
                }
            } catch (error) {
                console.error("Error initializing frames:", error);
            }
        };

        const fetchNextFrame = async () => {
            const nextFrameRequestBody = {
                fileid: props.fileId,
            };

            try {
                const nextFrameResponse = await fetch("/api/getNextFrame", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(nextFrameRequestBody),
                });

                if (nextFrameResponse.ok && !isCancelled) {
                    const frameData = await nextFrameResponse.json();
                    if (frameData.status !== "completed") {
                        setThumbnails((prev) => {
                            const newThumbnails = [...prev];
                            const index = newThumbnails.indexOf(null);
                            if (index !== -1) {
                                newThumbnails[index] = frameData;
                            }
                            return newThumbnails;
                        });
                        setTimeout(fetchNextFrame, 1000); // Интервал 1 секунда между запросами
                    } else {
                        console.log("All frames generated");
                    }
                } else if (
                    nextFrameResponse.status === 404 ||
                    nextFrameResponse.status === 500
                ) {
                    setThumbnails((prev) => {
                        const newThumbnails = [...prev];
                        const index = newThumbnails.indexOf(null);
                        if (index !== -1) {
                            newThumbnails[index] = null; // Оставляем скелетон
                        }
                        return newThumbnails;
                    });
                } else {
                    console.error(
                        "Error fetching next frame:",
                        nextFrameResponse.statusText
                    );
                }
            } catch (error) {
                if (!isCancelled) {
                    console.error("Error fetching next frame:", error);
                }
            }
        };

        if (props.duration) {
            fetchFrames();
        }

        return () => {
            isCancelled = true;
        };
    }, [props.duration, props.fileId]);

    useEffect(() => {
        setStartValue(convertToTime(sliderValue[0]));
        setEndValue(convertToTime(sliderValue[1]));
    }, [sliderValue]);

    const handleTrim = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowPlayer(false);
        const requestBody = {
            starttime: sliderValue[0],
            endtime: sliderValue[1],
            fileid: props.fileId,
            switchValue1: switchValue1, // добавьте это
            switchValue2: switchValue2,
            fadeInAudio: fadeInAudio,
            fadeInVideo: fadeInVideo,
            fadeOutAudio: fadeOutAudio,
            fadeOutVideo: fadeOutVideo,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/trimVideo?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleChangeSlider = (newValue) => {
        setSliderValue(newValue);
    };

    const handleChangeSwitch1 = () => {
        setSwitchValue1(!switchValue1);
        setSwitchValue2(false);
        console.log(switchValue1);
    };

    const handleChangeSwitch2 = () => {
        setSwitchValue2(!switchValue2);
        console.log(switchValue2);
    };

    const handleInputChange = (index, event) => {
        const timeValue = event.target.value;
        const [hours, minutes, seconds, milliseconds] =
            index === 0 ? startValue : endValue;
        const newSliderValue = [hours, minutes, seconds, milliseconds];
        newSliderValue[event.target.name] = parseInt(timeValue);

        const newTime =
            newSliderValue[0] * 60 * 60 * 1000 +
            newSliderValue[1] * 60 * 1000 +
            newSliderValue[2] * 1000 +
            newSliderValue[3];

        // Проверка на превышение продолжительности
        if (newTime > props.duration || newTime < 0) {
            return;
        }

        if (index === 0 && newTime <= sliderValue[1]) {
            setSliderValue([newTime, sliderValue[1]]);
        } else if (index === 1 && newTime >= sliderValue[0]) {
            setSliderValue([sliderValue[0], newTime]);
        }
    };

    const handleThumbnailClick = (time) => {
        setSliderValue([time, sliderValue[1]]);
        setStartValue(convertToTime(time));
        /* document.body.scrollIntoView({ behavior: "smooth", block: "start" }); */
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowPlayer(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const isMobileDevice = useMediaQuery({
        query: "(max-width: 768px)",
    });

    const reloadPage = () => {
        setShowPlayer(true);
        location.reload();
    };

    const handleCurrentTimeChange = (time) => {
        console.log(time);
    };

    const handleEndToStart = () => {
        setSliderValue([sliderValue[1], props.duration]);
        setStartValue(convertToTime(sliderValue[1]));
        setEndValue(convertToTime(props.duration));
    };

    const handleFadeInAudioChange = (checked) => {
        if (firstFadeInActivation) {
            setFadeInAudio(true);
            setFadeInVideo(true);
            setFirstFadeInActivation(false);
        } else {
            setFadeInAudio(checked);
        }
    };

    const handleFadeInVideoChange = (checked) => {
        if (firstFadeInActivation) {
            setFadeInAudio(true);
            setFadeInVideo(true);
            setFirstFadeInActivation(false);
        } else {
            setFadeInVideo(checked);
        }
    };

    const handleFadeOutAudioChange = (checked) => {
        if (firstFadeOutActivation) {
            setFadeOutAudio(true);
            setFadeOutVideo(true);
            setFirstFadeOutActivation(false);
        } else {
            setFadeOutAudio(checked);
        }
    };

    const handleFadeOutVideoChange = (checked) => {
        if (firstFadeOutActivation) {
            setFadeOutAudio(true);
            setFadeOutVideo(true);
            setFirstFadeOutActivation(false);
        } else {
            setFadeOutVideo(checked);
        }
    };

    function downloadFile(url) {
        setIsFileDownloading(true);
        setDownloadProgress(0);

        fetch(url)
            .then((response) => {
                const contentLength = response.headers.get("content-length");
                if (!contentLength) {
                    throw new Error(
                        "Content-Length response header is missing"
                    );
                }
                const total = parseInt(contentLength, 10);
                let loaded = 0;
                let lastProgress = 0;
                const reader = response.body.getReader();
                const chunks = [];

                function read() {
                    reader
                        .read()
                        .then(({ done, value }) => {
                            if (done) {
                                const blob = new Blob(chunks);
                                const downloadUrl =
                                    window.URL.createObjectURL(blob);
                                const link = document.createElement("a");
                                link.href = downloadUrl;
                                link.setAttribute("download", getFileName(url));
                                document.body.appendChild(link);
                                link.click();
                                link.parentNode.removeChild(link);
                                window.URL.revokeObjectURL(downloadUrl);
                                setIsFileDownloading(false);
                                setIsDownloading(true);
                                return;
                            }

                            chunks.push(value);
                            loaded += value.byteLength;

                            // Обновляем прогресс скачивания каждые 5%
                            const currentProgress = Math.floor(
                                (loaded / total) * 100
                            );
                            if (currentProgress >= lastProgress + 5) {
                                lastProgress = currentProgress;
                                setDownloadProgress(currentProgress);
                            }

                            read();
                        })
                        .catch((error) => {
                            console.error("Download error:", error);
                            setIsFileDownloading(false);
                        });
                }

                read();
            })
            .catch((err) => {
                console.error("Error downloading file:", err);
                setIsFileDownloading(false);
            });
    }

    return (
        <Container>
            {showPlayer && (
                <>
                    {props.videoUrl && (
                        <div>
                            <span
                                style={{
                                    marginLeft: "auto", // Это автоматически выравнивает элемент по правому краю
                                    marginRight: "auto", // Это автоматически выравнивает элемент по левому краю
                                    padding: "10px",
                                    backgroundColor: "red", // Заменено на "red" для красного цвета фона
                                    color: "white", // Изменено на "white" для белого цвета текста на красном фоне
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center", // Добавлено для горизонтального выравнивания
                                    zIndex: 9999, // Поднято наверх для отображения поверх остального контента
                                    margin: "10px 0",
                                }}
                            >
                                {tip4}
                            </span>
                            <AVReactPlayer
                                onCurrentTimeChange={handleCurrentTimeChange}
                                videoUrl={props.videoUrl}
                            />
                        </div>
                    )}
                    <div className="px-4 py-2">
                        <div>
                            {titleCurrentFile}: {props.fileName}
                        </div>
                        <ThumbnailContainer>
                            {thumbnails.map((thumbnail, index) =>
                                thumbnail ? (
                                    <Thumbnail
                                        key={index}
                                        src={thumbnail.filename}
                                        alt={`Thumbnail ${index + 1}`}
                                        onClick={() =>
                                            handleThumbnailClick(thumbnail.time)
                                        }
                                    />
                                ) : (
                                    <SkeletonThumbnail key={index} />
                                )
                            )}
                        </ThumbnailContainer>
                        <div style={{ position: "relative" }}>
                            <TooltipContainer>
                                <Tooltip>{formatTime(startValue)}</Tooltip>
                                <Tooltip>{formatTime(endValue)}</Tooltip>
                            </TooltipContainer>
                            <StyledSlider
                                value={sliderValue}
                                onChange={handleChangeSlider}
                                min={0}
                                max={props.duration}
                                step={1}
                                pearling
                                minDistance={1}
                                renderTrack={(props, state) => (
                                    <Track
                                        {...props}
                                        index={state.index}
                                        switchValue1={switchValue1}
                                    />
                                )}
                                renderThumb={Thumb}
                            />
                        </div>
                    </div>
                    {!switchValue2 && (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "1em",
                                }}
                            >
                                <Switch
                                    onChange={handleChangeSwitch1}
                                    checked={switchValue1}
                                />
                                <span
                                    style={{
                                        marginLeft: "10px",
                                        padding: "10px",
                                        backgroundColor: "lightblue",
                                        color: "darkblue",
                                        fontSize: "0.7em",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {tip1}
                                </span>
                            </div>
                        </>
                    )}

                    {!switchValue1 && (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "1em",
                                }}
                            >
                                <Switch
                                    onChange={handleChangeSwitch2}
                                    checked={switchValue2}
                                />
                                <span
                                    style={{
                                        marginLeft: "10px",
                                        padding: "10px",
                                        backgroundColor: "lightblue",
                                        color: "darkblue",
                                        fontSize: "0.7em",
                                        borderRadius: "4px",
                                    }}
                                >
                                    {tip2}
                                </span>
                            </div>
                        </>
                    )}

                    <div className="overflow-x-auto w-full">
                        <table className="table-auto w-full">
                            <thead>
                                <tr>
                                    {!isMobileDevice && (
                                        <th className="px-4 py-2 w-1/5"></th>
                                    )}
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleHours}
                                    </th>
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleMinutes}
                                    </th>
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleSeconds}
                                    </th>
                                    <th className="px-4 py-2 w-1/5 sm:text-xs md:text-sm lg:text-base">
                                        {titleMilliseconds}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {!isMobileDevice && (
                                        <td className="px-4 py-2">
                                            {titleStart}:
                                        </td>
                                    )}
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={0}
                                            value={startValue[0]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={1}
                                            value={startValue[1]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={2}
                                            value={startValue[2]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={3}
                                            value={startValue[3]}
                                            onChange={(e) =>
                                                handleInputChange(0, e)
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="4">
                                        <div className="px-4 py-2 flex items-center">
                                            <ButtonContainer>
                                                <StyledButton
                                                    onClick={handleEndToStart}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="w-6 h-6"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75"
                                                        />
                                                    </svg>
                                                </StyledButton>
                                            </ButtonContainer>
                                            <span
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "10px",
                                                    backgroundColor:
                                                        "lightblue",
                                                    color: "darkblue",
                                                    fontSize: "0.7em",
                                                    borderRadius: "4px",
                                                    display: "flex", // Добавлено для выравнивания SVG и текста по вертикали внутри span.
                                                    alignItems: "center", // Добавлено для выравнивания SVG и текста по вертикали внутри span.
                                                }}
                                            >
                                                {tip3}
                                            </span>
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    {!isMobileDevice && (
                                        <td className="px-4 py-2">
                                            {titleEnd}:
                                        </td>
                                    )}
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={0}
                                            value={endValue[0]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={1}
                                            value={endValue[1]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={2}
                                            value={endValue[2]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                    <td className="px-4 py-2">
                                        <input
                                            type="number"
                                            className="w-full px-2 py-1 sm:text-xs md:text-sm lg:text-base"
                                            name={3}
                                            value={endValue[3]}
                                            onChange={(e) =>
                                                handleInputChange(1, e)
                                            }
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ToggleButton onClick={() => setShowOptions(!showOptions)}>
                        {titleAdditionalOptions}
                    </ToggleButton>
                    <HiddenDiv show={showOptions}>
                        <div
                            style={{
                                position: "relative",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                                marginTop: "30px", // Добавлен отступ сверху, чтобы подсказка не наползала на кнопку выше
                            }}
                        >
                            <span
                                style={{
                                    position: "absolute",
                                    top: "-25px", // Поднимите подсказку над элементами
                                    left: "10px",
                                    padding: "10px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "0.7em",
                                    borderRadius: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    zIndex: 10, // Установите высокий z-index, чтобы подсказка была поверх всех элементов
                                }}
                            >
                                {tip5}
                            </span>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "20px",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                }}
                            >
                                <div
                                    style={{ flex: "1", paddingRight: "10px" }}
                                >
                                    <div style={{ marginBottom: "20px" }}>
                                        <label
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "100px",
                                                    textAlign: "right",
                                                    marginRight: "10px",
                                                }}
                                            >
                                                {titleFadeInAudio}
                                            </span>
                                            <Switch
                                                onChange={
                                                    handleFadeInAudioChange
                                                }
                                                checked={fadeInAudio}
                                            />
                                        </label>
                                        <label
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "100px",
                                                    textAlign: "right",
                                                    marginRight: "10px",
                                                }}
                                            >
                                                {titleFadeInVideo}
                                            </span>
                                            <Switch
                                                onChange={
                                                    handleFadeInVideoChange
                                                }
                                                checked={fadeInVideo}
                                            />
                                        </label>
                                    </div>
                                </div>
                                <div style={{ flex: "1", paddingLeft: "10px" }}>
                                    <div>
                                        <label
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "100px",
                                                    textAlign: "right",
                                                    marginRight: "10px",
                                                }}
                                            >
                                                {titleFadeOutAudio}
                                            </span>
                                            <Switch
                                                onChange={
                                                    handleFadeOutAudioChange
                                                }
                                                checked={fadeOutAudio}
                                            />
                                        </label>
                                        <label
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    width: "100px",
                                                    textAlign: "right",
                                                    marginRight: "10px",
                                                }}
                                            >
                                                {titleFadeOutVideo}
                                            </span>
                                            <Switch
                                                onChange={
                                                    handleFadeOutVideoChange
                                                }
                                                checked={fadeOutVideo}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </HiddenDiv>

                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={handleTrim}>
                                {titleTrim}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleTrimAnotherVideo}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>
                    <div className="px-4 py-2">
                        <AVReactPlayer
                            onCurrentTimeChange={handleCurrentTimeChange}
                            videoUrl={downloadUrl}
                        />
                    </div>
                    {isFileDownloading ? (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                /* height: "100px",
                                width: "100px", */
                                margin: "auto",
                            }}
                        >
                            <CircularProgressBar
                                value={Math.round(downloadProgress)}
                            />
                        </div>
                    ) : (
                        <ButtonContainer>
                            <a
                                href={downloadUrl}
                                onClick={(e) => {
                                    e.preventDefault();
                                    downloadFile(downloadUrl);
                                }}
                            >
                                <StyledButton>{titleDownload}</StyledButton>
                            </a>
                            <a className="pl-2" onClick={handleDownload}>
                                <StyledButtonDelete>
                                    {titleDelete}
                                </StyledButtonDelete>
                            </a>
                        </ButtonContainer>
                    )}
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleTrimAnotherVideo}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default AVTrimSlider;
